import { render, staticRenderFns } from "./SortableClientCard.vue?vue&type=template&id=4c1f69ba&scoped=true&"
import script from "./SortableClientCard.vue?vue&type=script&lang=js&"
export * from "./SortableClientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f69ba",
  null
  
)

export default component.exports